var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAp = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M11.1621 5.01367L15.2031 11.9697L13.9434 14.4473H11.1621L9.88379 11.9697H7.39844L6.12012 14.3154L4.79688 11.9697L6.12012 9.61621L8.62402 9.63184L7.39844 7.33301L8.62305 5.01367H11.1621ZM8.64062 9.63379L9.90137 11.9521H12.5127L9.97363 7.35938L8.64062 9.63379Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3Z",
  stroke: "white"
})))));
export default SvgAp;